<template>
  <div class="progress">
    <div class="final-progress-bar-size" :style="finalStyle">
      <div class="progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" :aria-valuenow="percentageDone" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentageDone: {
      type: Number,
      required: true
    }
  },

  computed: {
    finalStyle() {
      return {
        width: `${this.percentageDone}%`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  height: 100%;
  animation-duration: 2s;
  animation-name: fillup;
}

@keyframes fillup {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}
</style>
